import { render, staticRenderFns } from "./LogPontuacao.vue?vue&type=template&id=ceb93fd6&scoped=true"
import script from "./LogPontuacao.vue?vue&type=script&lang=ts"
export * from "./LogPontuacao.vue?vue&type=script&lang=ts"
import style0 from "./LogPontuacao.vue?vue&type=style&index=0&id=ceb93fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb93fd6",
  null
  
)

export default component.exports